import { InjectionToken } from "@angular/core";
import { IFullscreenPreviewModalService } from "./i-fullscreen-preview-modal.service";

export const fullscreenPreviewModalServiceInjectionToken: InjectionToken<IFullscreenPreviewModalService> = new InjectionToken<IFullscreenPreviewModalService>("digital-signage.user-dashboard.dashboard-web.FullscreenPreviewModalService");
